import PrivacyPage from "@/pages/landing/Privacy";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(landing)/privacy")({
  component: PrivacyPage,
});
